import {type TypeImplementation, match} from './TypeImplementation';

export const getAliasType = match({
  Custom: (_) => null,
  Alias: (val) => val.type,
  Unique: (_) => null,
});

export const getUniqueType = match({
  Custom: (_) => null,
  Alias: (_) => null,
  Unique: (val) => val.type,
});

export function getParams(impl: TypeImplementation) {
  return impl.params;
}

export function getRenderSummary(impl: TypeImplementation) {
  return impl.renderSummary;
}

export function getRender(impl: TypeImplementation) {
  return impl.render;
}

export function getIcon(impl: TypeImplementation) {
  return impl.icon;
}

// Getters from within `system`
export function getLabel(impl: TypeImplementation) {
  return impl.system && impl.system.label;
}

export function getBindUIVariant(impl: TypeImplementation) {
  return impl.system && impl.system.bindUIVariant;
}

export function getIsFullWidth(impl: TypeImplementation) {
  return impl.system && impl.system.isFullWidth;
}

export function getLabelVariant(impl: TypeImplementation) {
  return impl.system && impl.system.labelVariant;
}

export function getDefaultValue(impl: TypeImplementation) {
  return (fallback: any) =>
    impl.system && impl.system.hasOwnProperty('defaultValue')
      ? impl.system.defaultValue
      : fallback;
}

export function getDisplayName(impl: TypeImplementation) {
  return impl.system && impl.system.displayName;
}

export function getPrivate(impl: TypeImplementation) {
  return impl.system && impl.system.private;
}
